module.exports = {
  title: 'Fancy Color Carousel with Reanimated and Skia 🌈',
  author: 'Enzo Manuel Mangano',
  date: '2023-05-17',
  slug: 'color-carousel',
  tags: ['reanimated', 'skia'],
};
